import { Close } from '@mui/icons-material';
import { Chip, chipClasses } from '@mui/material';
import PropTypes from 'prop-types';

import { PRIMARY } from '../../../constants/color';

const FilterChip = ({ type, label, onRemove, variant = 'outlined', sx }) => (
  <Chip
    sx={{
      gap: '4px',
      display: 'flex',
      borderRadius: '4px',
      height: '37px',
      padding: '0 10px',
      [`& .${chipClasses.label}`]: {
        display: 'flex',
        gap: '4px',
        alignItems: 'center',
        paddingRight: 0,
        paddingLeft: 0,
      },
      [`& .${chipClasses.deleteIcon}`]: {
        marginLeft: 0,
        marginRight: 0,
        color: 'black',
      },
      '& .type-label': {
        color: '#84818A',
      },
      '& .chip-label': {
        color: PRIMARY,
      },
      ...sx,
    }}
    label={
      <>
        {type ? <span className='type-label text-[12px] font-medium'>{type}:</span> : null}
        <span className={'chip-label text-[14px] font-semibold'}>{label}</span>
      </>
    }
    deleteIcon={<Close sx={{ width: '14px', height: '14px' }} />}
    onDelete={onRemove}
    variant={variant}
  />
);

FilterChip.propTypes = {
  type: PropTypes.string,
  label: PropTypes.any,
  variant: PropTypes.string,
  onRemove: PropTypes.func,
  sx: PropTypes.object,
};

export default FilterChip;
